import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Header";
import Loader from "../../Utils/Loader";
import Select from "react-select";
import {
  handleGetApiGF,
  shareIphonePostMsg,
  Toast,
} from "../../Utils/general-function";
import Innerlistcommon from "./Innerlistcommon";
import { Shareurl, Userlogin } from "../../Utils/general-function";

import NoCars from "../../Utils/NoCars";
import Defaultpreview from "../../Utils/Defaultpreview";
import { useFuelContext } from "../../Contexts/FuelwiseCatalogContext";

function FuelwiseCatalog() {
  const [loading, setLoading] = useState(true);
  const [fuelList, setFuelList] = useState([]);
  const {
    selectedFuelObj,
    setSelectedFuelObj,
    branding,
    setBranding,
    carList,
    setCarList,
    countRef,
  } = useFuelContext();
  console.log("carList", carList);
  console.log("fuel", selectedFuelObj);

  const navigate = useNavigate();
  // set 0 value for showing div for first page load
  const userid = localStorage.getItem("Ca1itd");
  const iphone = window.navigator.userAgent.includes("Mac");

  const fullUrl = new URL(
    "/#/fuelwisecatalogshare/" +
      userid +
      "/" +
      selectedFuelObj?.Value +
      "/" +
      branding,
    window.location.origin,
  ).href; // sharing full url

  const fetchData = async () => {
    const res = await handleGetApiGF({ url: "/api/Common/Fueldata" });
    console.log("Fuel res", res);
    if (!res?.succ) {
      Toast(false, "", res?.msg);
      setLoading(false);
      setFuelList([]);
      return;
    }
    setFuelList(res?.data?.Data || []);
    setLoading(false);
  };

  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
      return;
    }
    fetchData();
  }, []);

  const handleDropchange = (obj) => {
    setSelectedFuelObj(obj);
    Submit(obj.Value);
  };

  const Submit = async (selectedmodel) => {
    // /api/Carmaster/GetdetailsofCarsbyRandomidfuelid?Randomid=fAg93QC&fuelid=2

    let obj = new URLSearchParams({
      Randomid: userid,
      fuelid: selectedmodel,
    }).toString();
    try {
      const res = await handleGetApiGF({
        url: "/api/Carmaster/GetdetailsofCarsbyRandomidfuelid?" + obj,
      });
      if (!res?.succ) {
        return Toast(false, "", res?.msg);
      }
      setCarList(res?.data?.Data || []);
      setLoading(false);
      countRef.current = 1;
    } catch (error) {
      console.log(error);
    }
  };
  const Onchange = (e) => {
    setBranding(e.target.value);
  };
  return (
    <div className="page-space" style={{ marginBottom: "56px" }}>
      <Header />
      <div className="text-center">
        <h2 className="page-title">Fuel Wise Catalog</h2>
      </div>
      {loading ? <Loader /> : null}
      {/*--------------- Search Module---------------------- */}
      <div className="search-div mt-2">
        <Select
          placeholder="Select Fuel"
          name="fuel"
          value={selectedFuelObj}
          options={fuelList}
          getOptionLabel={(option) => option.Text}
          getOptionValue={(option) => option.Value}
          onChange={(obj) => handleDropchange(obj, "fuel")}
          closeMenuOnSelect={true}
          blurInputOnSelect={false}
          isSearchable={true}
          styles={{
            dropdownIndicator: (base, state) => ({
              ...base,
              transition: "transform 0.25s ease",
              transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
            }),
            control: (provided, state) => ({
              ...provided,
              border: "1px solid red",
              boxShadow: state.isFocused ? "red" : "red",
              "&:hover": {
                borderColor: "red",
              },
            }),
          }}
          className="w-100"
        ></Select>
        {/* <button className="add-citybtn" onClick={() => Submit()}>
            <span className="material-symbols-outlined">arrow_forward</span>
          </button> */}
      </div>
      {/* ------------------Share Module------------------ */}
      {countRef.current === 0 ? (
        <Defaultpreview
          img="assets/images/search.png"
          msg="Quickly find cars in your account by model. Share the list of selected models as a catalog seamlessly!!"
        />
      ) : (
        <>
          {carList.length === 0 ? (
            <NoCars />
          ) : (
            <>
              <div className="p-3">
                <div className="text-center">
                  <div class="form-div">
                    <div>
                      <div class="form-check-inline">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="radio1"
                          name="optradio"
                          value="Wh_B"
                          onChange={Onchange}
                          checked={branding === "Wh_B" ? true : false}
                        />
                        <label class="form-check-label px-1" for="radio1">
                          Share With Branding
                        </label>
                      </div>
                      <div class="form-check-inline">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="radio2"
                          name="optradio"
                          value="Wo_hB"
                          onChange={Onchange}
                          checked={branding === "Wo_hB" ? true : false}
                        />
                        <label class="form-check-label px-1" for="radio2">
                          Share Without Branding
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ---------------Result module--------------------- */}
              <Innerlistcommon
                catloguelist={carList}
                onDataChangeProp={
                  (obj) => setCarList(obj?.catloguelists || [])
                  // purpose: fire when unsold car from this catalogue
                }
                scrollKey="specifiedCatlogueScrollPosition"
                from="gearwisecatalog"
              />
              <div className="fixshare">
                <button
                  className="sharebtn"
                  onClick={(e) => {
                    iphone
                      ? shareIphonePostMsg({
                          action: "urlshare",
                          url: fullUrl,
                        })
                      : Shareurl(fullUrl);
                  }}
                >
                  Fuel Wise Catalog
                  <span>
                    <img src="assets/images/share.png" alt="" />
                  </span>
                </button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default FuelwiseCatalog;
